<template>
    <div class="flex justify-start items-center gap-2">
        <AppLogoSvg class="w-5 h-5" />
        <span class="font-semibold text-lg whitespace-nowrap">
            {{ appName }}
        </span>
    </div>
</template>

<script setup lang="ts">
    import AppLogoSvg from '@/Shared/Component/AppLogoSvg.vue'

    interface AppLogoProps {
        appName: string
    }

    const props = defineProps<AppLogoProps>()
</script>
